import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { authFetch } from '@/lib/auth';
import { Globe } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const fmt = (iso) => new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Phoenix' });

export const WebsiteRequests = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    authFetch(`${API_BASE}/api/listings/admin/requests`).then((r) => (r.ok ? r.json() : { requests: [] })).then((d) => setRows(d.requests)).catch(() => setRows([]));
  }, []);
  if (!rows?.length) return null;
  return (
    <section className="rounded-2xl border border-white/10 bg-[#0a1120] p-5 sm:p-6" data-testid="admin-website-requests">
      <h2 className="flex items-center gap-2 text-white text-lg font-light"><Globe className="h-5 w-5 text-[#C6A14A]" />Property website requests</h2>
      <ul className="mt-4 divide-y divide-white/5">
        {rows.slice(0, 8).map((r) => (
          <li key={r.id} className="py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1" data-testid={`website-request-${r.id}`}>
            <div>
              <Link to={`/admin/real-estate-orders/${r.order_id}`} className="text-white hover:text-[#C6A14A]">{r.address}</Link>
              <p className="text-xs text-[#E8E4DE]/50">{[r.name, r.email].filter(Boolean).join(' · ') || 'Signed-in client'}{r.is_owner ? ' · gallery owner' : ''}</p>
            </div>
            <span className="text-xs text-[#E8E4DE]/40">{fmt(r.created_at)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

// Note on the admin order page when someone asked for a property website for this gallery.
export const WebsiteRequestNote = ({ orderId }) => {
  const [req, setReq] = useState(null);
  useEffect(() => {
    authFetch(`${API_BASE}/api/listings/admin/requests?order_id=${orderId}`).then((r) => (r.ok ? r.json() : { requests: [] }))
      .then((d) => setReq(d.requests[0] || null)).catch(() => {});
  }, [orderId]);
  if (!req) return null;
  return (
    <div className="flex items-start gap-3 rounded-xl border border-[#C6A14A]/30 bg-[#C6A14A]/10 p-4 text-sm" data-testid="order-website-request-note">
      <Globe className="h-5 w-5 text-[#C6A14A] shrink-0" />
      <p className="text-[#E8E4DE]">
        <span className="text-white font-medium">Property website requested</span> on {fmt(req.created_at)}
        {req.name || req.email ? ` by ${[req.name, req.email].filter(Boolean).join(' · ')}` : ''}.
      </p>
    </div>
  );
};
